/*
 * settings:
 *  margin:  Default is "0 0 10px 0."  Pass in a valid css string to overwrite.
 *  padding:  Default is "2px."  Pass in a valid css string to overwrite.
 *  useTransparentBackground:  Default is false.  Set to true to have a transparent background.
 *  printToolbar:  Default is false.  Set to true to have the toolbar show when the page is printed.
 */

(function () {
    "use strict";

    var ToolbarPartControl = Solovis.defineClass(
        "Solovis.Reports.Parts.ToolbarPartControl",
        Solovis.Reports.Parts.PartControl,
        function (options) {
            var self = this;

            this.dataSets = null;

        });    

    ToolbarPartControl.prototype.doInit = function () {
        var self = this;
        
    };

    ToolbarPartControl.prototype.doRender = function () {
        var self = this;
        if (!this.dataSets) {
            return;
        }

        this.container.html("");

        var margin = this.settings.margin ? this.settings.margin : "0 0 10px 0";
        var padding = this.settings.padding ? this.settings.padding : "2px";

        this.container
            .css("margin", margin)
            .css("padding", padding);

        var toolbarOptions = this.settings;

        toolbarOptions.container = this.container;

        this.toolbar = new (Solovis.UI as any).Toolbar(toolbarOptions);

        if (this.settings.printToolbar) {
            var toolbarContainer = this.toolbar.getContainer();
            if (toolbarContainer) {
                toolbarContainer.removeClass("no-print");
            }
        }

        var toolbarItems = this.settings.toolbarItems ? this.settings.toolbarItems : null;
        if (typeof toolbarItems == "function") {
            toolbarItems = toolbarItems.call(this);
        }


        if (toolbarItems) {
            $(toolbarItems).each(function (i, toolbarItem) {
                self.toolbar.addItem(toolbarItem);
            });
        }
    };

    ToolbarPartControl.prototype.doDestroy = function () {
        if (this.settings.destroy) {
            try {
                this.settings.destroy.call(this);
            }
            catch (error) {
                console.log(error);
            }
        }
    };

})();